import Vue from 'vue'
import {
  Toast,
  Dialog,
  ActionSheet,
  Popup,
  Circle,
  Picker
} from 'vant'

Vue.use(Toast)
Vue.use(Dialog)
Vue.use(ActionSheet)
Vue.use(Popup)
Vue.use(Circle)
Vue.use(Picker)
